// Client runtime config. VITE_SERVER_URL is inlined at build time.
export const SERVER_URL = import.meta.env.VITE_SERVER_URL ?? "http://localhost:2567";
export const INTERP_DELAY_MS = 100;
